import moment from 'moment';

import { DEFAULT_FIXED_TIME } from '../constants';
import type { EditEdutainmentFormValues } from './types';

export const INIT_FORM_VALUES: EditEdutainmentFormValues = {
  name: '',
  category: null,
  plans: [],
  teacher: null,
  maximumEnrollment: null,
  minimumEnrollment: null,
  enrollment: {
    startTime: null,
    endTime: null,
  },
  description: '',
  includedPayment: '',
  note: '',
  image: null,
  isPaidProgram: true,
  payments: ['creditCard'],
  pricing: {
    member: {
      price: null,
      point: null,
      limit: null,
    },
    nonMember: {
      price: null,
      point: null,
      limit: null,
    },
  },
  isRegular: true,
  irregular: {
    place: null,
    address: null,
  },
  program: {
    startTime: null,
    endTime: null,
  },
  scheduleType: ['fixedTime'],
  fixedSchedule: Array.from({ length: 7 }, () => DEFAULT_FIXED_TIME),
  nonFixedSchedule: [
    {
      date: null,
      startTime: null,
      endTime: null,
      place: null,
      address: null,
    },
  ],
};

// TODO: 純測試用，開發完記得刪
export const TEST_EDUTAINMENT_DETAIL: EditEdutainmentFormValues = {
  name: '創意芳香手工皂',
  category: '技藝',
  plans: ['銅卡會員', '翡翠卡會員', '鑽卡會員'],
  teacher: '劉玉慈',
  maximumEnrollment: 50,
  minimumEnrollment: 20,
  enrollment: {
    startTime: moment(1754956800000),
    endTime: moment(1756598400000),
  },
  description:
    '想了解體驗渲染皂及手工皂製作看這邊！食用油份製作，全部採用天然材料！帶著一顆',
  includedPayment: '入場費',
  note: `1.本活動可供非住戶者報名，費用與住戶相同。
2.遲到30分鐘以上或缺席者，視同放棄上課資格，不予退還訂金。
3.將以拍照、錄影等方式，紀錄學員製作過程及作品，並分享在社群平台。`,
  image: null,
  isPaidProgram: true,
  payments: ['creditCard', 'point'],
  pricing: {
    member: {
      price: 150,
      point: 150,
      limit: 30,
    },
    nonMember: {
      price: 150,
      point: 150,
      limit: 20,
    },
  },
  isRegular: true,
  irregular: {
    place: null,
    address: null,
  },
  program: {
    startTime: moment(1759276800000),
    endTime: moment(1769817600000),
  },
  scheduleType: ['fixedTime'],
  fixedSchedule: Array.from({ length: 7 }, (_, index) => {
    if (index === 0) {
      return {
        isDayChecked: true,
        startTime: moment('13:00', 'HH:mm'),
        endTime: moment('15:30', 'HH:mm'),
        place: '娛樂室',
        address: null,
      };
    }
    return DEFAULT_FIXED_TIME;
  }),
  nonFixedSchedule: [
    {
      date: null,
      startTime: null,
      endTime: null,
      place: null,
      address: null,
    },
  ],
};
